<template>
    <main class="about-static" v-bar
          @scroll.prevent
          @touchmove.capture="scrollIfScrollable"
          @touchend.capture="scrollIfScrollable"
          @wheel.capture="scrollIfScrollable">
        <div ref="scrollWrapper" class="scroll-wrapper">
            <div ref="scrollContent" class="scroll-content">
                <div class="container">
                    <section id="about">
                        <h1 class="section-title _shadowed _page-title">ABOUT</h1>
                        <h2 class="section-subtitle"><b>오늘은 경리단길에서 놀자!</b></h2>
                        <h2 class="about-date">2018.07.20 - 2018.08.31</h2>
                        <div class="about-contents">
                            <p>경리단길의 다양한 로컬 스팟을 중심으로 지역 내 크리에이터들과 함께 동네를 상세히 보고 즐기는 특별한 기회를 선사합니다. 동네 축제 ‘연남위크‘, ‘연희걷다‘, 매거진 ≪아는동네≫등 로컬 콘텐츠를 참신하게 풀어내는 어반플레이의 2018년 아는동네 로컬 프로젝트 ‘오늘은 경리단’.</p>
                            <p>지금 바로 경험하세요!</p>
                            <a class="to-somewhere" href="http://www.urbanplay.co.kr" target="_blank">어반플레이 홈페이지 바로가기</a>
                            <a href="http://www.iknowhere.co.kr" target="_blank"><img class="to-iknowhere" src="~@/assets/iknowhere-logo.svg"></a>
                        </div>
                    </section>
                    <section id="program">
                        <section-title container=".scroll-wrapper">PROGRAM</section-title>
                        <h2 class="section-subtitle _promo">특별한 추억을 만들어줄<br><b>오늘은 경리단 프로그램</b></h2>
                        <img class="image _single" src="~@/assets/coupon.jpg">
                        <p class="section-caption _program">* <b>오늘은 경리단</b> 프로그램은<br>1차와 2차로 나누어져서 오픈됩니다.</p>
                        <div class="program__outer-lists row">
                            <div class="col col-12 col768-6">
                                <span class="wave-label">1차 프로그램</span>
                                <div class="program__lists">
                                    <about-list type="dining"/>
                                    <about-list type="experience"/>
                                    <about-list type="concert"/>
                                    <about-list type="class"/>
                                </div>
                            </div>
                            <div class="col col-12 col768-6">
                                <span class="wave-label _second">2차 프로그램</span>
                                <div class="program__lists">
                                    <about-list type="dining" :second-wave="true"/>
                                    <about-list type="experience" :second-wave="true"/>
                                    <about-list type="concert" :second-wave="true"/>
                                    <about-list type="class" :second-wave="true"/>
                                </div>
                            </div>
                        </div>
                        <router-link class="to-somewhere" :to="{ name: 'programs' }"><b>프로그램</b> 자세히보기</router-link>
                    </section>
                    <section id="goods">
                        <section-title container=".scroll-wrapper">GOODS</section-title>
                        <h2 class="section-subtitle _promo">경리단길의 매력을 모아 만든<br><b>오늘은 경리단 굿즈</b></h2>
                        <div class="goods__images row">
                            <div class="goods__image col col-6">
                                <img class="image" src="~@/assets/goods01.jpg">
                                <h3 class="goods__label">HANDY FAN</h3>
                                <p class="goods__caption">부채</p>
                            </div>
                            <div class="goods__image col col-6">
                                <img class="image" src="~@/assets/goods02.png">
                                <h3 class="goods__label">STICKER</h3>
                                <p class="goods__caption">스티커</p>
                            </div>
                        </div>
                        <p class="section-caption">* 쿠폰북과 굿즈는<br><b>오늘은 경리단</b> 로컬 스팟에서 배포하고 있습니다.</p>
                    </section>
                    <section id="coupon-book">
                        <section-title container=".scroll-wrapper">COUPON BOOK</section-title>
                        <h2 class="section-subtitle _promo">경리단길의 핫플레이스 할인정보가 모두 여기에<br><b>오늘은 경리단 쿠폰북</b></h2>
                        <img class="image _single" src="~@/assets/couponbook.jpg">
                    </section>
                    <section class="bottom">
                        <section-title container=".scroll-wrapper">NOW, GET!</section-title>
                        <div class="bottom__wrapper"
                             v-scrollee="{ container: '.scroll-wrapper' }"
                             @scrollee="handleBottomScrollee">
                            <p class="bottom__emoji">🤫</p>
                            <h1 class="bottom__title">혼자만 알고 계세요!</h1>
                            <router-link class="link-button" :to="{ name: 'coupon' }">쿠폰북 혜택 알아보기</router-link>
                        </div>
                    </section>
                    <div class="bottom-stickers" :class="{ active_: stickersActive }">
                        <img class="bottom-sticker _n1" src="~@/assets/sticker06.png">
                        <img class="bottom-sticker _n2" src="~@/assets/sticker07.png">
                    </div>
                </div>
            </div>
        </div>
    </main>
</template>

<script>
import { SwipeChecker } from '@/directives/swipe'
import { store } from '@/stores'
import { getters } from '@/stores/programs'

import AboutList from './AboutList'

export default {
    name: 'AboutStatic',
    components: {
        AboutList
    },
    props: {
        scrollable: Boolean
    },
    data() {
        return {
            bottomBorder: null,
            swipeChecker: new SwipeChecker({ wheelDelta: 0, touchDelta: 0 }),
            stickersActive: false
        }
    },
    computed: {
        programs() {
            return store.getters[getters.firstWave]
        },
        scrollWrapper() {
            return this.$refs.scrollWrapper
        },
        scrollContent() {
            return this.$refs.scrollContent
        }
    },
    methods: {
        handleBottomScrollee(e) {
            console.log(!!e.detail)
            this.stickersActive = !! e.detail
        },
        getScrollTop() {
            return this.scrollWrapper.scrollTop
        },
        scrollIfScrollable(e) {
            if (! this.scrollable) {
                e.stopPropagation()
                e.preventDefault()
                return
            }
            if (this.getScrollTop() > 0) {
                e.stopPropagation()
            }
            else {
                const swipeDirection = this.swipeChecker.check(e)
                if (swipeDirection !== 'up') {
                    e.stopPropagation()
                }
                else {
                    e.preventDefault()
                }
            }
        }
    }
}
</script>

<style scoped lang="scss">
@import '~@/styles/_parts';

.about-static {
    height: 100%;
    color: #efefef;
}
.scroll-wrapper {
    position: relative;
    z-index: 1;
}
.scroll-content {
    position: relative;
    @include footer-pad();
}
.container {
    overflow: visible;
    position: relative;
}

.section-subtitle,
.about-date {
    text-align: center;
}

.section-title {
    @include modifier(shadowed) {
        @include g-text-shadow();
    }
    @include modifier(lined) {
        &::before {
            content: '';
            background: #fff;
            height: 1px;
            position: absolute;
            top: 50%;
            right: 0;
            left: 0;
        }
    }
}
.mask._section-title {
    background: #342264;
    padding-right: em(40, 19);
    padding-left: em(40, 19);
    position: relative;
    z-index: 1;
}

.section-subtitle {
    margin-top: em(48);
    @include media(768) {
        margin-top: em(100);
    }
    &._promo {
        font-size: em(14);
        line-height: em(24, 14);
        margin-top: em(30, 14);
        margin-bottom: em(30, 14);
    }
}

.section-caption {
    font-size: em(12);
    line-height: em(20, 12);
    margin: em(100, 12) auto 0;
    text-align: center;
    word-break: keep-all;
    &._program {
        margin-top: 36px;
    }
}
.to-somewhere {
    max-width: 330px;
    border: 1px solid #fff;
    display: block;
    font-size: em(14);
    line-height: em(52, 14);
    margin: 40px auto 0;
    text-align: center;
}

#about {
    margin-top: em(48);
}
.about-date {
    font-size: em(14);
    margin-top: em(12, 14);
}
.about-contents {
    max-width: 500px;
    font-size: em(14);
    line-height: em(24, 14);
    margin: 42px auto 0;
    text-align: justify;
    word-break: break-all;
    > * + * {
        margin-top: em(24, 14);
    }
}
.to-somewhere {
    margin-top: 48px;
}
.to-iknowhere {
    width: 76px;
    display: block;
    margin: 70px auto 0;
}

#program {
    margin-top: 124px;
}
.wave-label {
    width: 146px;
    border: 1px solid #fff;
    border-radius: em(18);
    display: block;
    font-weight: 800;
    line-height: em(36);
    margin: 40px auto 35px;
    text-align: center;
    &._second {
        margin-top: 52px;
        @include media(768) {
            margin-top: 40px;
        }
    }
}
.about-list {
    width: 260px;
    margin: 24px auto 0;
}

#coupon-book,
#goods,
.bottom {
    margin-top: 112px;
}

.image {
    width: 100%;
    display: block;
    &._single {
        max-width: 500px;
        margin: auto;
    }
}

.goods__image {
    text-align: center;
    &:first-child {
        padding-right: 2px;
    }
    &:last-child {
        padding-left: 2px;
    }
}
.goods__label {
    font-size: em(14);
    font-family: 'Fugaz One', cursive;
    margin-top: 1em;
}
.goods__caption {
    font-size: em(12);
    margin-top: .25em;
}

.bottom__wrapper {
    position: relative;
    z-index: 1;
}
.bottom__emoji {
    font-size: em(30);
    text-align: center;
    @include media(768) {
        font-size: em(38);
    }
}
.bottom__title {
    font-size: em(18);
    line-height: em(26, 18);
    margin-top: em(3, 18);
    text-align: center;
}
.bottom-stickers {
    bottom: 0;
}
.bottom-stickers.active_ .bottom-sticker {
    &._n2 {
        transition-delay: 250ms;
    }
}
.bottom-sticker {
    &._n1 {
        width: em(248);
        bottom: em(23);
        left: em(-121);
        transform: translateY(100vh) rotate(25deg);
        transition: transform 750ms $ease-in;
        @include media(640) {
            left: em(12);
            bottom: em(62);
        }
        @include media(768) {
            bottom: em(112);
        }
    }
    &._n2 {
        width: em(208);
        right: em(-121);
        bottom: em(76);
        transform: translateY(100vh) rotate(-30deg);
        transition: transform 650ms $ease-in;
        @include media(640) {
            right: em(32);
        }
        @include media(768) {
            bottom: em(132);
        }
    }
}
</style>